/* eslint-disable prettier/prettier */
/* eslint-disable */

import React from 'react';

import clsx from 'clsx';

import ResultDoughnut from '../../../common/ResultDoughnut';
import { getDoughnutData, getDoughnutGradeColor, getDoughnutValue } from '../../../../utils';

import './index.scss';
import { DoughnutColors } from 'const';

interface ISubjectResultTileProps {
  doughnutValue?: number;
  altValue?: string;
  description: string;
  selected: boolean;
  isInteger?: boolean;
}

const LIME_DOUGHNUT_VALUE = ['Б/О', 'ЗЧ'];

// Проверяет не пришли ли оценочные значения в безоценочном поле
const isAltValueNumber = (value?: string) => {
  if (!value) {
    return false;
  }

  const number = Number(value);
  return number >= 0 && number <= 5;
};

const getSubjectValue = (doughnutValue?: number, altValue?: string) => {
  if (!altValue) {
    return doughnutValue;
  }

  if (isAltValueNumber(altValue)) {
    return Number(altValue);
  }

  return 0;
};

const SubjectResultTile: React.FC<ISubjectResultTileProps> = ({
  doughnutValue,
  altValue,
  description,
  selected,
  isInteger = false,
}) => {
  const isAltNumber = isAltValueNumber(altValue);
  const subjectValue = getSubjectValue(doughnutValue, altValue);

  const color =
    altValue && !isAltNumber
      ? LIME_DOUGHNUT_VALUE.includes(altValue.toUpperCase())
        ? DoughnutColors.LIME
        : DoughnutColors.RED
      : getDoughnutGradeColor(subjectValue ?? 0);

  return (
    <div className={clsx('subject-result-tile tile', { 'subject-result-tile--selected': selected })}>
      <ResultDoughnut
        total={altValue ?? getDoughnutValue(subjectValue, isInteger)}
        data={getDoughnutData(altValue ? 5 : subjectValue ?? 0, 5)}
        color={color}
        borderThickness={85}
      />
      <div className="tile__text-content">
        <p className="subject-result-tile__description">{description}</p>
      </div>
    </div>
  );
};

export default SubjectResultTile;
